export const AMOUNT_FILTERS = [
  { label: 'Greater than', value: 'amount_over' },
  { label: 'Equal to', value: 'amount_equal_to' },
  { label: 'Less than', value: 'amount_under' },
];
export const FRAUD = {
  fraud_score_min: 'fraud_score_min',
  fraud_score_max: 'fraud_score_max',
};
